import { useThrottleEventListener } from 'hooks';
import React, { useState } from 'react';


const ScrollToTopBtn: React.FC = () => {
  const [isVisible, setVisible] = useState(false);
  useThrottleEventListener('scroll', () =>
    setVisible(document.documentElement.scrollTop > 180)
  );

  return (
    <>
      {isVisible && (
        <button
          data-id="button-scroll-to-top"
          className="fixed z-[3] right-[10px] sm:right-12 top-[calc(100vh-300px)] sm:top-[580px] flex items-center justify-center w-10 h-10 rounded-full transition-opacity delay-1000 ease-in-out shadow-md bg-white"
          onClick={scrollToTop}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 19V5"
              stroke="#91121C"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 12L12 5L19 12"
              stroke="#91121C"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </>
  );
};

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

export default ScrollToTopBtn;
